//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);


//store
const entidad = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        Aentidad: [],
        entidades: [],
        entidadeslist: [],
        entidadreporta: [],
    }
}).get({
    action: "Getentidad",   
    path: function () {
        return `/entidad`;
    },
    onSuccess: (state, payload ) => {
        state.entidades = payload.data;
    }

}).get({
    action: "Getentidadbyid",   
    path: function (obj) {
        return `/entidad/porid/${obj.identidad}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Aentidad = payload.data;
    }
}).get({
    action: "get_entidaddetallesector",
    path: function (obj) {
        return `/entidad/detalle/sector/puntos/${obj.idsector}/${obj.idperiodo}`;
    },
    onSuccess: (state, payload) => {
        state.entidades = payload.data;
    }
}).get({
    action: "get_entidadreporta",
    path: function (obj) {
        return `/entidad/entidadreporta/${obj.idindicador}`;
    },
    onSuccess: (state, payload) => {
        state.entidadreporta = payload.data;
    }
}).get({
    action: "get_entidaddetallesectorPDF",
    path: function (obj) {
        return `/entidad/detalle/puntos/${obj.idperiodo}`;
    },
    onSuccess: (state, payload) => {
        state.entidadeslist = payload.data;
    },
    onError: (state, error) => { 
        store.dispatch("mensaje/set_error", error);   
    }
}).get({
    
    action: "get_entidadesbysector",
    path: function (obj) {
        return `/entidad/sector/${obj.idsector}`;
    },
    onSuccess: (state, payload) => {
        state.entidades = payload.data;
    }
}).get({
    action: "get_entidaddetalleclasificacionessector",
    path: function (obj) {
        return `/entidad/detalle/sector/clasificaciones/${obj.idsector}/${obj.idperiodo}`;
    },
    onSuccess: (state, payload) => {
        state.entidades = payload.data;
    }
}).get({
    action: "get_entidaddetalleclasificacionessectorDPF",
    path: function (obj) {
        return `/entidad/detalle/sector/clasificaciones/${obj.idsector}/${obj.idperiodo}`;
    },
    onSuccess: (state, payload) => {
        state.entidadeslist = payload.data;
    }
}).put({
    action: "PutEntidad", 
    path: function () {
        return `/entidad/putentidad`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        error.idGenerado = -1;
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

entidad.getters = {
    gentidad: state => {
        return state.entidades;
    },
    gentidadbyid: state => {
        return state.Aentidad;
    },
    gentidades: state => {
        return state.entidades
    },
    gentidadesPDF: state => {
        return state.entidadeslist
    },
    gentidadreporta: state => {
        return state.entidadreporta
    }    
}

export default entidad;


